import { type ReactNode, useState } from 'react';
import { DropdownContext } from './DropdownContext';

export function DropdownProvider({ children }: { children: ReactNode }) {
  const [parentSelected, setParentSelected] = useState(false);
  const [dropdownSelected, setDropdownSelected] = useState(false);

  const open = parentSelected || dropdownSelected;

  return (
    <DropdownContext.Provider
      value={{
        open,
        parentSelected,
        setParentSelected,
        dropdownSelected,
        setDropdownSelected,
      }}
    >
      {children}
    </DropdownContext.Provider>
  );
}
